import { useEffect, useState } from "react";
import { scrollToSection } from "@/lib/lenis";

const LOGO_URL = "/images/logo.png";

const links = [
  { label: "Manifesto", target: "#manifesto", testid: "nav-manifesto-link" },
  { label: "Product", target: "#product", testid: "nav-product-link" },
  { label: "Capabilities", target: "#capabilities", testid: "nav-capabilities-link" },
  { label: "On Site", target: "#on-site", testid: "nav-onsite-link" },
  { label: "Contact", target: "#contact", testid: "nav-contact-link" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-xl border-b border-black/5 transition-shadow duration-300 ${scrolled ? "shadow-[0_1px_24px_rgba(0,0,0,0.06)]" : ""}`}
    >
      <div className="px-6 md:px-12 lg:px-24 h-16 md:h-20 flex items-center justify-between">
        <button
          data-testid="header-logo-button"
          onClick={() => scrollToSection("#top")}
          className="flex items-center gap-3"
        >
          <img src={LOGO_URL} alt="Obrigado PH Holdings" className="h-9 md:h-11 w-auto mix-blend-multiply" />
        </button>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.label}
              data-testid={l.testid}
              onClick={() => scrollToSection(l.target)}
              className="font-mono text-[11px] uppercase tracking-[0.2em] text-ink/70 hover:text-chrome transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <button
          data-testid="header-enquiry-cta"
          onClick={() => scrollToSection("#contact")}
          className="bg-ink text-paper font-mono text-[11px] uppercase tracking-[0.2em] px-5 py-3 hover:bg-chrome transition-colors duration-300"
        >
          Start an Enquiry
        </button>
      </div>
    </header>
  );
};
